module.exports = __webpack_public_path__ + "static/media/christine.8b34eeeb.jpg";